import { IFilter, TFilter } from '../../types/filters';
import { advancedFilters } from './advancedFilters';
import { area } from './area';
import { bedrooms } from './bedrooms';
import { beds } from './beds';
import { cottageVillage } from './cottageVillage';
import { dates } from './dates';
import { dealType } from './dealType';
import { geo } from './geo';
import { landArea } from './landArea';
import { offerType } from './offerType';
import { price } from './price';
import { roomType } from './roomType';
import { villageMortgageAllowed } from './villageMortgageAllowed';

export const FILTERS: { [key in TFilter]: IFilter } = {
  advancedFilters,
  area,
  bedrooms,
  beds,
  cottageVillage,
  dates,
  dealType,
  geo,
  landArea,
  offerType,
  price,
  roomType,
  villageMortgageAllowed,
};
